import { Country } from "./country";

export class CountryDto {
  constructor(public results: Country[]) { }
}
